/**
 * Supabase Client Configuration
 * Used for Google OAuth authentication
 */

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.warn('Supabase credentials missing. Google OAuth will not work.');
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '');
